import * as API from 'generated/api';

export const API_KEY = process.env.REACT_APP_API_KEY; 

export const apiHost = process.env.REACT_APP_API_HOST || 'localhost';
export const grpcHost = process.env.REACT_APP_GRPC_HOST;

export function apiKeyHeaders(): Record<string, string> {
  const out: Record<string, string> = {};
  if (API_KEY) {
    out['ApiToken'] = API_KEY;
  }
  return out;
}

export const apiConfiguration = () => new API.Configuration({
  basePath: `${apiHost}/api/v1`,
});
